/**
 * DÖNEMSEL GETİRİ SINIRLARI (gelir modeli, kullanıcı kararı 20.10.2026):
 *   - ücretsiz: en çok 3 varlık; kıyas serileri ve sepet yok;
 *   - geçiş paketi ("kendi"): kendi hesaplarındaki varlıkların hepsi; kendi
 *     varlıkları 3'ten azsa dışarıdan 3'e tamamlar, 3 ya da daha çoksa
 *     dışarıdan ekleyemez; kıyas serileri ve sepet yok;
 *   - Dönemsel Getiri kabiliyeti ("sinirsiz"): bütün sınırlar kalkar.
 * Motorun kendi üst sınırı (`DONEMSEL_MAX_ARAC`) her kipte geçerli.
 *
 * Kayıtlı tercih SİLİNMEZ: ekran sınırlara göre süzülmüş "etkin" tercihle
 * çalışır; kabiliyet açılınca kayıtlı seçim olduğu gibi geri gelir.
 */

import { DONEMSEL_MAX_ARAC } from "@parafon/contracts/local-api";
import { UCRETSIZ, type Sinirlar } from "@parafon/contracts/sertifika";
import type { DonemselTercih } from "../lib/donemselTercih";

export interface DonemselKural {
  readonly mod: Sinirlar["donemsel"];
  readonly enCok: number;
  readonly kiyasAcik: boolean;
  readonly sepetAcik: boolean;
  /** `null` = her varlık; değilse yalnızca bunlar (kendi varlıkları). */
  readonly yalnizKendi: ReadonlySet<string> | null;
}

export function donemselKurali(mod: Sinirlar["donemsel"], kendi: ReadonlySet<string>): DonemselKural {
  if (mod === "sinirsiz") return { mod, enCok: DONEMSEL_MAX_ARAC, kiyasAcik: true, sepetAcik: true, yalnizKendi: null };
  if (mod === "ucretsiz" || kendi.size < UCRETSIZ.donemselVarlik) {
    return { mod, enCok: UCRETSIZ.donemselVarlik, kiyasAcik: false, sepetAcik: false, yalnizKendi: null };
  }
  return { mod, enCok: DONEMSEL_MAX_ARAC, kiyasAcik: false, sepetAcik: false, yalnizKendi: kendi };
}

export function secilebilir(k: DonemselKural, id: string, kiyas: boolean): boolean {
  if (kiyas) return k.kiyasAcik;
  return k.yalnizKendi === null || k.yalnizKendi.has(id);
}

/** Ekranın kullandığı tercih + sınırın bir şeyi kısıp kısmadığı. */
export function etkinDonemselTercih(
  t: DonemselTercih,
  k: DonemselKural,
  kiyasMi: (id: string) => boolean,
  enEski: string | undefined,
): { readonly tercih: DonemselTercih; readonly kisildi: boolean } {
  const secili = t.secili.filter((id) => secilebilir(k, id, kiyasMi(id))).slice(0, k.enCok);
  const sepetAcik = t.sepetAcik && k.sepetAcik;
  const yalnizSepet = t.yalnizSepet && k.sepetAcik;
  const eski = enEski !== undefined && t.from !== "" && t.from < enEski;
  const tercih: DonemselTercih = {
    ...t,
    secili,
    sepetAcik,
    yalnizSepet,
    ...(eski ? { from: enEski, donem: null } : {}),
  };
  const kisildi =
    secili.length !== t.secili.length || sepetAcik !== t.sepetAcik || yalnizSepet !== t.yalnizSepet || eski;
  return { tercih, kisildi };
}
